/**
 * Binding site → tournoi (build-time).
 * Priorité runtime globale : ?tournoi= > REACT_APP_TOURNOI_KEY > current == true
 */
export function getConfiguredTournoiKey(): string | undefined {
  const raw = process.env.REACT_APP_TOURNOI_KEY;
  if (typeof raw !== "string") return undefined;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function getConfiguredFrontBaseUrl(): string | undefined {
  const raw = process.env.REACT_APP_FRONT_BASE_URL;
  if (typeof raw !== "string") return undefined;
  const trimmed = raw.trim().replace(/\/$/, "");
  return trimmed.length > 0 ? trimmed : undefined;
}

export function getRuntimeFrontBaseUrl(): string {
  const fromEnv = getConfiguredFrontBaseUrl();
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "https://tournoi.sqyping.fr";
}
